export default function arrayToString(
  arr: any[],
  separator: string = ",",
  attribute: string = "id"
) {
  return arr.map(item => item[attribute]).join(separator);
}
